import styled from 'styled-components';
import { Panel, SectionLabel, Button, useToast } from '@/ui';
import { useCommunities, useRequireAuth } from '@/hooks';
import { CommunityIcon } from '../CommunityIcon';

const List = styled.ul`list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 12px;`;
const Item = styled.li`display: flex; align-items: center; gap: 10px;`;
const Info = styled.div`flex: 1; min-width: 0; display: flex; flex-direction: column;`;
const Name = styled.span`font-family: ${({ theme }) => theme.font.body}; font-weight: 600; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary};`;
const Sub = styled.span`font-family: ${({ theme }) => theme.font.mono}; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted};`;
const Actions = styled.div`display: flex; gap: 6px;`;
const Empty = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;

export function CommunityInvitesPanel() {
  const { invites } = useCommunities();
  const toast = useToast();
  const requireAuth = useRequireAuth();
  function act(label: string) {
    if (!requireAuth('respond to invites')) return;
    toast(`${label}: invites are coming soon`);
  }
  return (
    <Panel>
      <SectionLabel as="h2">Community Invites</SectionLabel>
      {invites.length === 0 ? (
        <Empty>No pending invites.</Empty>
      ) : (
        <List>
          {invites.map((inv) => (
            <Item key={inv.id}>
              <CommunityIcon svg={inv.icon} size={34} />
              <Info><Name>{inv.name}</Name><Sub>{inv.members}</Sub></Info>
              <Actions>
                <Button variant="outline" size="sm" onClick={() => act('Accepted')}>Accept</Button>
                <Button variant="secondary" size="sm" onClick={() => act('Declined')}>Decline</Button>
              </Actions>
            </Item>
          ))}
        </List>
      )}
    </Panel>
  );
}
